<div fxFlex.lt-md="1 0 100%" fxFlex.md="100" class="tutorial-video__container">
  <div
    class="tutorial-video__container-video"
    [ngStyle]="{ 'background-image': urlThumbnailVideo }"
    (click)="onClickVideo()"
  >
    <mat-icon class="icon-ic_play-round"></mat-icon>
  </div>
  <div class="tutorial-video__container-text">
    <div *ngIf="data.category" color="accent" class="chip_type">{{ category }}</div>
    <span #tutorialTitle class="padding-left tutorial-video__title tutorial__description">{{ data.title }}</span>
    <p #tutorialDescription [class]="descriptionClass">{{ data.description }}</p>
  </div>
</div>
